var map = {
	"./de.svg": "./src/assets/pre/ny-subtitle/de.svg",
	"./en.svg": "./src/assets/pre/ny-subtitle/en.svg",
	"./es.svg": "./src/assets/pre/ny-subtitle/es.svg",
	"./fr.svg": "./src/assets/pre/ny-subtitle/fr.svg",
	"./it.svg": "./src/assets/pre/ny-subtitle/it.svg",
	"./pt.svg": "./src/assets/pre/ny-subtitle/pt.svg",
	"./ru.svg": "./src/assets/pre/ny-subtitle/ru.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/pre/ny-subtitle sync recursive ^\\.\\/.*\\.svg$";